import { render } from "./RemoveMenuModifier.vue?vue&type=template&id=7a7d7fc3&scoped=true"
import script from "./RemoveMenuModifier.vue?vue&type=script&lang=js"
export * from "./RemoveMenuModifier.vue?vue&type=script&lang=js"

import "./RemoveMenuModifier.vue?vue&type=style&index=0&id=7a7d7fc3&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a7d7fc3"]])

export default __exports__